function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("mask", {
  id: "a",
  fill: "#fff"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.293 15.293a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0 2a8.5 8.5 0 100-17 8.5 8.5 0 000 17z"
})), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.293 15.293a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414z",
  fill: "#666"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0 2a8.5 8.5 0 100-17 8.5 8.5 0 000 17z",
  fill: "#666"
}), React.createElement("path", {
  d: "M16.707 15.293l-1.414 1.414 1.414-1.414zm4 4l1.414-1.414-1.414 1.414zm-2.586-5.414a3 3 0 00-4.242 0l2.828 2.828a1 1 0 01-1.414 0l2.828-2.828zm4 4l-4-4-2.828 2.828 4 4 2.828-2.828zm0 4.242a3 3 0 000-4.242l-2.828 2.828a1 1 0 010-1.414l2.828 2.828zm-4.242 0a3 3 0 004.242 0l-2.828-2.828a1 1 0 011.414 0L17.88 22.12zm-4-4l4 4 2.828-2.828-4-4-2.828 2.828zm0-4.242a3 3 0 000 4.242l2.828-2.828a1 1 0 010 1.414L13.88 13.88zM15 10.5a4.5 4.5 0 01-4.5 4.5v4a8.5 8.5 0 008.5-8.5h-4zM10.5 6a4.5 4.5 0 014.5 4.5h4A8.5 8.5 0 0010.5 2v4zM6 10.5A4.5 4.5 0 0110.5 6V2A8.5 8.5 0 002 10.5h4zm4.5 4.5A4.5 4.5 0 016 10.5H2a8.5 8.5 0 008.5 8.5v-4zm6.5-4.5a6.5 6.5 0 01-6.5 6.5v4C16.299 21 21 16.299 21 10.5h-4zM10.5 4a6.5 6.5 0 016.5 6.5h4C21 4.701 16.299 0 10.5 0v4zM4 10.5A6.5 6.5 0 0110.5 4V0C4.701 0 0 4.701 0 10.5h4zm6.5 6.5A6.5 6.5 0 014 10.5H0C0 16.299 4.701 21 10.5 21v-4z",
  fill: "#666",
  mask: "url(#a)"
})));